import { useEffect, useRef } from 'react';
import { useStateStorage } from 'store/state';

export const useSoundEffect = (soundFile = `/notification_sound.wav`) => {
  const { soundVolume, isSoundMuted } = useStateStorage();

  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = isSoundMuted ? 0 : soundVolume;
    }
  }, [undefined, soundVolume, isSoundMuted]);

  if (!audioRef.current && typeof Audio !== 'undefined') {
    audioRef.current = new Audio(soundFile);
  }

  const play = (volume?: number) => {
    if (audioRef.current) {
      audioRef.current.volume =
        volume !== undefined ? volume : isSoundMuted ? 0 : soundVolume;
      audioRef.current.currentTime = 0;
      audioRef.current.autoplay = true;
      audioRef.current.play().catch(error => {
        console.warn('Sound playback failed:', error);
      });
    }
  };

  return play;
};
